import { PaintedScene } from '../PaintedScene';

export const DONCHITOS_HAMLET_RESTORED_PHASER_KEY = 'DonchitosHamletRestoredScene' as const;
export const DONCHITOS_HAMLET_RESTORED_MANIFEST_KEY = 's-102-donchitos-hamlet-restored' as const;

export class DonchitosHamletRestoredScene extends PaintedScene {
  constructor() {
    super(DONCHITOS_HAMLET_RESTORED_PHASER_KEY, DONCHITOS_HAMLET_RESTORED_MANIFEST_KEY);
  }
}
